import { WprBaseViewModeInfo } from '../../../wpr-framework/mode/WprBaseViewMode';
import { PlanComponentView } from '../PlanComponentView';
import { WprDI_Control } from '../../../wpr-framework/view/di/WprDI_Control';
import { WprControlInfo } from '../../../wpr-framework/view/control/WprControlInfo';

/**
 * プラン選択モード
 */
export class PlanSelectMode extends WprBaseViewModeInfo<PlanComponentView> {
	// DI情報  ------------------------------------------------------------------
	@WprDI_Control
	private m_Type: WprControlInfo = null;		// プラン選択情報
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('planSelectMode');
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * モードリスト取得（この画面モードで使用する全てのモードを定義する）
	 * @param list モードリスト
	 */
	public useModeList(list: string[]): void {
		list.push('reasonable');
		list.push('standard');
		list.push('premium');
		list.push('初期');
	}

	/**
	 * フィールド定義を登録処理
	 */
	public onRegisterControl(): void {
		this.addControl('type', { check: true });
		const option1 = { class: [{ mode: 'reasonable', class: 'checked'}, { mode: 'other', class: ''},],};
		const option2 = { class: [{ mode: 'standard', class: 'checked'}, { mode: 'other', class: ''},],};
		const option3 = { class: [{ mode: 'premium', class: 'checked'}, { mode: 'other', class: ''},],};
		this.addControl('reasonablebtn', option1);
		this.addControl('li1_1', option1);
		this.addControl('li1_2', option1);
		this.addControl('li1_3', option1);
		this.addControl('li1_4', option1);
		this.addControl('li1_5', option1);
		this.addControl('li1_6', option1);
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START
		this.addControl('li1_8', option1);
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END
		this.addControl('standardbtn', option2);
		this.addControl('li2_1', option2);
		this.addControl('li2_2', option2);
		this.addControl('li2_3', option2);
		this.addControl('li2_4', option2);
		this.addControl('li2_5', option2);
		this.addControl('li2_6', option2);
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START
		this.addControl('li2_8', option2);
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END
		this.addControl('premiumbtn', option3);
		this.addControl('li3_1', option3);
		this.addControl('li3_2', option3);
		this.addControl('li3_3', option3);
		this.addControl('li3_4', option3);
		this.addControl('li3_5', option3);
		this.addControl('li3_6', option3);
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START
		this.addControl('li3_8', option3);
		// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END
	}

	/**
	 * 画面の状態をチェックしてモードを変更する
	 * @param curMode 現在のモード
	 * @return 新しいモード（変更ない場合は現在のモード）
	 */
	public onCheckMode(curMode: string): string {
		if(this.m_Type.value === 'reasonable')
			return 'reasonable';
		else if(this.m_Type.value === 'premium')
			return 'premium';
		else if(this.m_Type.value === 'standard') 
			return 'standard';
		else
			return '初期';
	}
}